<template>
    <div class="c-app flex-row align-items-center login">
      <CContainer>
        <CRow class="justify-content-center">
          <CCol class="col-12">
            <CAlert color="danger" closeButton :show.sync="loginError">
              {{ loginError }}
            </CAlert>
  
            <div class="col-12 p-0 m-auto tablet-bg-12 tablet-sm-8">
              <CCard class="border-card col-md-5 col-sm-12 mx-auto card--custom
                  animate__animated animate__fadeIn " >

                <CCardBody>
                  <div class="card-header mb-4 pb-0">
                    <h2 class="text-center mb-0">Bienvenido</h2>          
                    <p class="text-center mb-3 mt-1 with-lines" style="color: rgba(128, 128, 128, 0.568);">Ingresa a tu cuenta</p>
                  </div>
                  <CForm @submit.prevent="checkForm" class="p-3">
                    <div class="input-group mb-3" style="border-radius: 30%;">
                      <button class="btn btn-outline-secondary border-button" type="button" id="button-addon1" disabled><i class="far fa-user"></i></button>
                      <input type="text" class="form-control" v-model="usuario.userName" placeholder="Usuario" autocomplete="username">
                    </div>
                    <div class="input-group mb-3" style="border-radius: 30%;">
                      <button class="btn btn-outline-secondary border-button" type="button" id="button-addon1" disabled><i class="fas fa-unlock"></i></button>
                      <input type="password" class="form-control" v-model="usuario.password" placeholder="Password" autocomplete="curent-password">
                    </div>
                    <div class="login__errors">
                      <div
                        class="
                          alert alert-danger
                          animate__animated animate__slideInUp animate__faster
                        "
                        v-for="(error, i) in errors"
                        :key="i"
                      >
                        {{ error }}
                      </div>
                    </div>
  
                    <div class="form-group mt-4 d-flex justify-content-center">
                      <button style="border-radius: 15px; height: 40px;"
                        class="btn btn-primary--custom flex-grow-1 mt-2"
                        @click="coverLoading"
                      >
                        Iniciar sesión
                      </button>
                    </div>

                    <div class="text-center mb-3 fs-14">
                      <div>
                        <p class="mt-4 mb-0" style="font-size: 13px;">¿Olvidaste tu contraseña?</p>
                        <a
                          @click="recuperarPasswoord"
                          class=" pointer link"
                          >Recupera el acceso a tu cuenta</a
                        >
                      </div>
                    </div>
                    <div class="text-center card-footer fs-14">
                      <div>
                        <p class="mt-1 mb-0" style="font-size: 13px;">¿No tienes cuenta?</p>
                        <a
                          @click="openModalRegistrate"
                          class=" pointer link"
                          >Registrate</a
                        >
                      </div>
                    </div>
                  </CForm>
                </CCardBody>
              </CCard>
            </div>
          </CCol>
        </CRow>
      </CContainer>
      <RegistrateModal
      @formularioCompletado="manejarFormulario"
      :cleanModal.sync="cleanModal"
      ref="registrate"
      />
      <ErrorModal
      :errorMessage="errorMessage"/>
      <RecuperarPasswordModal
      @Usuario="sendPassword"/>
      <SuccessModal
      :successrMessage="successMessage"/>
      <Loading :isLoading="isLoading"/>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import RegistrateModal from "../sas/Modals/registrateModal.vue";
  import RecuperarPasswordModal from "../sas/Modals/recuperarPasswordModal.vue";
  import ErrorModal from "./Modals/errorModal.vue";
  import SuccessModal from "./Modals/successModal.vue";
  import Loading from "./Tools/loading.vue";
  
  export default {
    name: "Login",
    components: {
      RegistrateModal,
      Loading,
      ErrorModal,
      SuccessModal,
      RecuperarPasswordModal,
    },

    data() {
      return {
        //loginExter
        usuarioSASP: {
          userName: "900650",
          password: "123456",
        },

        //generales
        errors: [],
        usuario: {
          userName: "",
          password: "",
        },
        expression: /^[A-Za-z0-9!@#$%^&*()_+{}|:"<>?~\-[\]\\;',./]+$ /,
        isLoading: false,
        errorMessage: '',
        successMessage: '',
        idaplicacion: '',

        //registrar
        datosFormularios: {},
        cleanModal: false,
      };
    },
    methods: {
      checkForm: function (e) {
        this.errors = [];
        if (!this.usuario.userName) this.errors.push("Usuario requerido");
        if (!this.usuario.password) {
          this.errors.push("Password requerido");
          this.coverLoading(false);
        } else if (
          // !this.expression.test(this.usuario.password) ||
          this.usuario.password.length < 3
        ) {
          this.errors.push("Password Invalido");
          this.coverLoading(false);
        }
        if (!this.errors.length) {
          this.$store.dispatch("loginSas", {usuario: this.usuario});
        } else {
          e.preventDefault();
          return true;
        }
      },
      coverLoading(show = true) {
        this.$store.state.Loading = true;
        if (!show) {
          this.$store.state.Loading = false;
        }
      },
      //registrate
      async openModalRegistrate(){
        this.$modal.show('registro')
        this.$refs.registrate.limpiarControles()
        await this.$store.dispatch("loginExtern", this.usuarioSASP);
        this.getRol()
      },
      async manejarFormulario(datosFormularios) {
        this.isLoading = true;
        this.datosFormularios = datosFormularios // Manejar los datos recibidos del formulario hijo
        console.log(this.datosFormularios);
        const payload = {
          metodo: "REGISTROUSUARIO",
          data: {
            Usuario: {
                IdSexo: 0,
                IdTipoPersona: 0, //1 PERSONA FÍSICA , 2PERSONA MORAL
                IdEstadoCivil: 0,
                IdArea: 70, //siniestro personas 25
                IdTipoUsuario: 7, //Para pago a provedores es el 7
                IdUsuarioApp: "",  //no se manda
                Nombre: this.datosFormularios.Nombre,  //para razon socialtodo sobre el nombre
                Apaterno: "",
                Amaterno: "",
                Usuario: this.datosFormularios.RFC, //obligatorio  rfc
                Password: "",
                ConfirmacionPassword: "",
                RutaFoto: "",
                Activo: 1,
                IdRool: this.idaplicacion, //para proveedor
                RFC: this.datosFormularios.RFC,
                IdAplicacion:"26"
            },
            DomicilioUsuario: [
                { //lista de domicilio
                    Calle: null,
                    NumExterior: null,
                    NumInterior: null,
                    IdEstado: 0,
                    Estado: null,
                    IdMunicipio: 0,
                    Municipio: null,
                    IdColonia: 0,
                    Colonia: null,
                    Cp: null
                }
            ],
            ContactoUsuario: [ //lista de contacto
                {
                    TIPOCONTACTO: 3, //- 1    TELÉFONO PRINCIPAL  2 TELÉFONO ECUNDARIO 3 CORREO ELECTRÓNICO
                    VALOR: this.datosFormularios.Email
                }
            ],
            Validaciones: {
                ValidaEmail: true,
                ValidaRfc: true,
                ValidaPassIgual: false,
                AplicaSeguridadPassword: false,
                ValidaCondiciones: true,
                GeneraPassword: true,
                ValidaGeneraCorreoConPass: false,
                ValidaGeneraCodigoVerificador: false,
                ValidaGeneraCorreoConPassProveedor: true
            },
            DatosProveedor: {
              DatosGenerales: {
                  IDTITULO: 3, //SERVICIOS MÉDICOS SINIESTROS PERSONAS
                  IDPRODUCCIONECONOMICA: 1, //Servicios
                  IDONBASE: "",
                  IDSISE: "",
                  IDINVITACION: "",
                  TIPOPERSONA: "", //persona moral o  persona fisica
                  IDOCUPACIONPROF: 0,
                  OCUPACIONPROF: "",
                  ESTADOCIVIL: "",
                  SEXO: "",
                  IDNACIONALIDAD: 155, //155 MEXICO
                  NACIONALIDAD: "MEXICO",
                  IDPAIS: 0,
                  PAIS: "",
                  FECHANAC: "1900-01-01",
                  LUGARNAC: "",
                  CURP: "",
                  NOMBRECORTO: this.datosFormularios.Nombre  //nombre comercial
              }
            }
          },
          };
          
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
              const res = this.$store.getters.getRespuestaREST;
              if (res != "") {
                this.successMessage = 'Usuario registrado exitosmente.'
                this.$modal.hide('registro');
                this.$modal.show('success-modal');
              }
              console.log(res);
            } else {
              this.errorMessage = this.$store.getters.getDataRaw.errorMessage
              this.$modal.show('error-modal');
            }
          } //Fin try
          catch (error) {
              console.log(error);
          }
          this.isLoading = false;
      },
      async getRol() {
        this.isLoading = true;
        const payload = {
          metodo: "GETAPPPORROLSAS",
          data: { }
          };
          
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
              const res = this.$store.getters.getRespuestaREST;
              if (res != "") {
                res.map( (data, i) => {
                  if(data.descripcion == 'PROVEEDOR') { this.idaplicacion = data.idrol;
                    console.log(this.idaplicacion);
                  }
                })
              }
            } else {
            }
          } //Fin try
          catch (error) {
              console.log(error);
          }
          this.isLoading = false;
      },
      //recuperar password
      recuperarPasswoord(){
        this.$modal.show('recuperar-contrasena')
        this.$store.dispatch("loginExtern", this.usuarioSASP);
      },
      async sendPassword(usuario){
        console.log(usuario);
        // this.rfcPassword = rfc
        if (usuario == '') {
          this.$modal.show('error-modal')
          this.errorMessage = 'Es necesario ingresar un usuario valido.'
          this.$modal.hide('recuperar-contrasena')
          return;
        }
        this.isLoading = true;
        const payload = {
            metodo: "GETUSERFULL",
            data: {
              usuario: usuario,
              tipobusqueda: "2"
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        console.log(info);
        if (info == "") {
          let error = this.$store.getters.getDataRaw.errorMessage
          this.$modal.show('error-modal')
          this.errorMessage = error
          this.$modal.hide('recuperar-contrasena')
          
        } else {
          console.log(info);
          let email = info.contactos[0].valor
          this.desencriptarPassword(info.usuario.password, email)
          const atIndex = email.indexOf('@');
          if (atIndex <= 3) this.text = email;
          const start = email.slice(0, 3);
          const masked = '*'.repeat(atIndex - 3);
          this.successMessage = `La contraseña sera enviada al correo: ${start}${masked}${email.slice(atIndex)}`
          this.$modal.show('success-modal')
          this.$modal.hide('recuperar-contrasena')
          
        }
        // this.isLoading = false;
        })
      },
      async desencriptarPassword(password, email){
        this.isLoading = true;
        const payload = {
            metodo: "DECRYPTPASSWORD",
            data: {
              valorin: password,
              valorout: '',
              tipo: "2"
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        console.log(info);
        this.emailPassword(info.valorout, email)
        })
        // this.isLoading = false;
      },
      async emailPassword(pass, email){
        this.isLoading = true;
        const payload = {
              metodo: "SENDEMAILSAS",
              data: {
                idTemplate:"105",
                sender:"tramites.sasp@latinoseguros.com.mx",  //correo de donde sale
                subject: "Recuperación de contraseña",
                targets: email,  //correo a donde llega
                dinamicContent: `${pass}`,     
                idMessage:"105"   //id de plantilla
              },
            };
          this.$store.dispatch("metodoPost", payload).then(() => {
          const info = this.$store.getters.getRespuestaREST;
          console.log(info);
          })
          this.isLoading = false;
      },

    },
    async mounted(){
      // this.$modal.show('recuperar-contrasena');
      // await this.$store.dispatch("loginExtern", this.usuarioSASP);
    },
    computed: {
      ...mapState(["loggingIn", "loginError", "loginSuccessful"]),
    },
  };
  </script>
  <style scoped>
  .card-header{
    color: rgb(240, 243, 255) !important;
    background-color: rgb(255, 255, 255) !important;
    border-bottom: 0px solid;
  }
  .border-card{
    border-radius: 30px !important;
  }
  input {
    border-top-right-radius: 15px !important; 
    border-bottom-right-radius: 15px !important; 
    height: 50px !important;
  }
  .border-button {
    border-top-left-radius: 15px; 
    border-bottom-left-radius: 15px; 
    /* height: 50px; */
  }
  .vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 30px !important;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}
  .with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid rgba(128, 128, 128, 0.568);
    margin: 0 10px;
}
.link {
  color: #64908a;
}
.link:hover{
  color: #64908a;
  font-weight: 600;
}
  </style>
  